import * as React from 'react';
import Menu from '@material-ui/core/Menu';

const CustomMenu = (props) => {
    return <Menu {...props} />;
};

export { CustomMenu as Menu };
